module.exports = require('crypto').createHmac



//////////////////
// WEBPACK FOOTER
// ./node_modules/create-hmac/index.js
// module id = 423
// module chunks = 0